<template>
    <div class="item item-basket" >
        <el-popover placement="bottom-end" width="440" trigger="click" popper-class="checkout-popover">
            <div class="icon-block pointer" slot="reference" @click="index">
                <div class="badge">{{ quantity }}</div>
                <i class="el-icon-shopping-bag-2"></i>
            </div>
            <div class="container" v-loading="pageLoading">
                <div class="empty vertical" v-if="!quantity">
                    <div class="empty-icon">
                        <svg-icon source="shop" />
                    </div>
                    <div class="empty-text">
                        <div class="empty-title">Sepetin Şu An Boş.</div>
                        <div class="empty-description">Seviyenize uygun alternatif gün ve saatleriyle çok yakında başlayacak olan online yabancı dil eğitimlerimiz.</div>
                    </div>
                </div>

                <template v-if="quantity && summary">
                    <div class="body">
                        <template v-for="(product, index) in summary.products">
                            <div class="product" :key="index">
                                <div class="content">
                                    <div class="media">
                                        <svg-icon :source="findProductIcon(product.type)" />
                                    </div>
                                    <div class="text">
                                        <div class="title">{{ product.title }}</div>
                                        <div class="description">{{ $n(product.price, 'currency') }}</div>
                                    </div>
                                </div>
                                <div class="action" @click="destroy(product.id)">
                                    <div class="icon-block pointer">
                                        <i class="el-icon-delete"></i>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="footer">
                        <div class="footer-wrp fluid">
                            <div class="sub-total">
                                <div class="column text">
                                    <span class="colored-secondary">Genel</span> Toplam
                                </div>
                                <div class="column price">
                                    {{ $n(summary.total, 'currency') }}
                                </div>
                            </div>
                            <a href="/checkout" class="el-button large secondary fluid">
                                Alışverişi Tamamla
                            </a>
                        </div>
                    </div>
                </template>
            </div>
        </el-popover>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DESTROY_CHECKOUT_ADD_TO_BASKET, GET_CHECKOUT_QUANTITY, GET_CHECKOUT_SUMMARY} from "~/store/actions.type";

export default {
    name: 'Checkout',
    data() {
        return {
            pageLoading: false
        }
    },
    computed: mapGetters(['account', 'quantity', 'summary']),
    mounted() {
        this.$store.dispatch(GET_CHECKOUT_QUANTITY);
    },
    methods : {
        index() {
            this.pageLoading = true;

            this.$store
                .dispatch(GET_CHECKOUT_SUMMARY)
                .then((response) => {
                    this.pageLoading = false;
                    localStorage.setItem('total', response.data ? response.data.total : 0)
                })
                .catch(() => {
                    this.pageLoading = false;
                })
        },

        destroy(id) {
            this.$confirm(this.$t('notification.destroy'), this.$t('notification.warning_title'), this.confirmOption)
                .then(() => {
                    this.pageLoading = true;

                    this.$store
                        .dispatch(DESTROY_CHECKOUT_ADD_TO_BASKET, id)
                        .then(() => {
                            this.index();
                        })
                        .catch(() => {
                            this.pageLoading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('notification.destroy_cancel')
                    });
                });
        }
    }
}
</script>
